import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {User} from '../models/user';
import {Observable, of, throwError} from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import {ApiResponse} from '../models/api.response';


@Injectable()
export class SpiChartsService {

  title = { text: '', x: 'left', textStyle: {  fontSize: 13, color: '#515253' }};
  grid = { left: 20, 'right': 20, 'top': 75,'bottom': 60, 'containLabel': true };
  tooltip = { show: true, 'trigger': 'axis', 'axisPointer': {'type': 'cross' } };
  legend = {  show: true, 'bottom': 5, 'type': 'scroll', 'data': [] };
  toolbox = { show: true, 'showTitle': true,
    feature: { mark: { show: true },
      dataZoom: { show: true, title: { zoom: 'area zooming', 'back': 'restore area zooming' }
      },
      magicType: { show: true, 'type': ['line', 'bar', 'stack'],  title: { 'line': 'for line chartsA', 'bar': 'for bar charts', 'tiled': 'for tiled charts' }},
      saveAsImage: { show: true, title: 'save as image', 'lang': ['Right-click to save as picture']  }
    }
  };
  dataZoom = { show: true, start: 0, end: 100, bottom: 35, handleSize: 30, height: 22 };


  constructor() { }

  getDefaultConfig2AxisChart() {

    let opt = {
      title: {},
      grid: {},
      animation: true, calculable: true, animationEasing: 'elasticOut',
      tooltip: {},
      legend: {},
      toolbox: {},
      dataZoom: { },
      xAxis: { type: 'category', data: [], },
      yAxis:[{ type: 'value', }] ,
      series: [],
    };

    opt.title = this.title;
    opt.grid = this.grid;
    opt.tooltip = this.tooltip;
    opt.legend = this.legend;
    opt.toolbox = this.toolbox;
    opt.dataZoom = this.dataZoom;

    return opt;
  }

  getDefaultConfigPieChart() {
    let opt = {
      title: {
        show: false,
        text: '',
      },
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)'
      },
      legend: {
        bottom: '10',
        data: []
      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: '60%',
          center: ['50%', '40%'],
          data: [],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };

    return opt;
  }

}
